module.exports = __webpack_public_path__ + "img/Marca21.e610f512.jpg";